import coveredWarrantService from '../../../../core/services/Market/Watchlist/CoveredWarrantService';
import ConstCommon from '../../../common/Const';
import currentState from '../../../helpers/CurrentState';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import {
  callApiSystemSetting,
  getUserSettingState,
  getWatchlistUserSetting,
} from '../../../main-layout/sidebar/reducer';
import ConstSummary from '../summary/Const';
import { hideColumns, ignoreColumns, listColumn } from './Const';

export const REDUCER_NAME = 'WATCH_LIST_COVERED_WARRANT';
export const FETCH_COVERED_WARRANT_SUCCESS = `${REDUCER_NAME}_FETCH_COVERED_WARRANT_SUCCESS`;
export const SET_LOADING = `${REDUCER_NAME}_SET_LOADING`;
export const CHANGE_HIDE_COLUMN = `${REDUCER_NAME}_CHANGE_HIDE_COLUMN`;
export const RESET_DATA = `${REDUCER_NAME}_RESET_DATA`;
export const ADD_COVERED_WARRANT = `${REDUCER_NAME}_ADD_COVERED_WARRANT`;
export const REMOVE_COVERED_WARRANT = `${REDUCER_NAME}_REMOVE_COVERED_WARRANT`;
export const UPDATE_COVERED_WARRANT = `${REDUCER_NAME}_UPDATE_COVERED_WARRANT`;

export const resetCWData = () => ({ type: RESET_DATA });

export const updateCoveredWarrantData = data => ({
  type: UPDATE_COVERED_WARRANT,
  payload: data,
});

export const removeCoveredWarrant = code => ({
  type: REMOVE_COVERED_WARRANT,
  payload: code,
});

export const addCoveredWarrant = coveredWarrant => ({
  type: ADD_COVERED_WARRANT,
  payload: coveredWarrant,
});

export const fetchCoveredWarrant = watchlistId => async dispatch => {
  dispatch(setLoading());
  try {
    let func = coveredWarrantService.getCoveredWarrants.bind(
      coveredWarrantService,
    );
    if (watchlistId !== ConstSummary.defaultCoveredWarrant) {
      func = coveredWarrantService.getCoveredWarrantWatchlist.bind(
        coveredWarrantService,
      );
    }
    const coveredWarrants = await func({ WatchListId: watchlistId });
    if (coveredWarrants.errors) {
      return;
    }
    dispatch({
      type: FETCH_COVERED_WARRANT_SUCCESS,
      payload: formatData(coveredWarrants.items),
    });
    dispatch(setLoading(false));
  } catch (e) {
    dispatch(setLoading(false));
  }
};

export const changeListHideColumnIndex = columns => (dispatch, getState) => {
  const finalColumns = columns.concat(ignoreColumns);
  const userSetting = getUserSettingState(getState());
  const wlSetting = getWatchlistUserSetting(getState()) || {};
  wlSetting.cwHideColumns = finalColumns;
  const newUserSetting = {
    ...userSetting,
    watchListSetting: JSON.stringify(wlSetting),
  };
  if (JSON.stringify(wlSetting) !== userSetting.watchListSetting) {
    dispatch(callApiSystemSetting(newUserSetting));
  }

  dispatch({
    type: CHANGE_HIDE_COLUMN,
    payload: finalColumns,
  });
};

export const setLoading = (isLoading = true) => ({
  type: SET_LOADING,
  payload: isLoading,
});

const formatData = data => {
  const codes = [];
  const dataByCode = {};
  const dataByOrganCode = {};
  data.sort(function(a, b) {
    if (a.ticker < b.ticker) {
      return -1;
    }
    if (a.ticker > b.ticker) {
      return 1;
    }
    return 0;
  });
  data.forEach(warrant => {
    codes.push(warrant.coveredWarrantCode);
    dataByCode[warrant.coveredWarrantCode] = warrant;
    dataByOrganCode[warrant.organCode] = warrant.coveredWarrantCode;
  });

  return {
    codes,
    dataByCode,
    dataByOrganCode,
  };
};

const initialState = {
  codes: [],
  dataByCode: {},
  dataByOrganCode: {},
  isLoading: true,
  listHideColumnIndex: hideColumns,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COVERED_WARRANT_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CHANGE_HIDE_COLUMN:
      if (action.payload.length === Object.keys(listColumn).length) {
        return {
          ...state,
          listHideColumnIndex: action.payload.filter(
            col => col !== listColumn.TICKER,
          ),
        };
      }
      return {
        ...state,
        listHideColumnIndex: [...action.payload],
      };
    case RESET_DATA:
      return {
        ...initialState,
        isLoading: false,
      };
    case ADD_COVERED_WARRANT:
      return {
        ...state,
        codes: [
          ...new Set(state.codes.concat(action.payload.coveredWarrantCode)),
        ],
        dataByCode: {
          ...state.dataByCode,
          [action.payload.coveredWarrantCode]: action.payload,
        },
      };
    case UPDATE_COVERED_WARRANT:
      return {
        ...state,
        dataByCode: {
          ...state.dataByCode,
          ...action.payload,
        },
      };
    case REMOVE_COVERED_WARRANT:
      return {
        ...state,
        codes: state.codes.filter(code => code !== action.payload),
      };
    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
